import { morph, MORPH_OPTIONS } from '@theme/morph';

/**
 * PcdShopTrigger — fetches a product page and opens the theme's quick-add
 * modal, morphing only the children of [data-product-grid-content] into
 * #quick-add-modal-content (matching how QuickAddComponent.updateQuickAddModal works).
 *
 * Usage:
 *   <pcd-shop-trigger data-product-url="/products/my-product">
 *     <button>Shop this look</button>
 *   </pcd-shop-trigger>
 */
class PcdShopTrigger extends HTMLElement {
  /** @type {Map<string, Element>} */
  #cache = new Map();

  connectedCallback() {
    this.addEventListener('click', (e) => {
      if (!e.target.closest('button')) return;
      e.preventDefault();
      this.#trigger();
    });
  }

  async #trigger() {
    const url = this.dataset.productUrl;
    if (!url) return;

    const dialog = document.getElementById('quick-add-dialog');
    const modalContent = document.getElementById('quick-add-modal-content');
    if (!dialog || !modalContent) return;

    let gridContent = this.#cache.get(url);

    if (!gridContent) {
      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = doc.querySelector('[data-product-grid-content]');

        if (grid) {
          gridContent = grid;
          this.#cache.set(url, grid);
        }
      } catch {
        return;
      }
    }

    if (gridContent) {
      // Morph children-only: copies productGrid's children into modalContent,
      // preserving modalContent's own attributes (id, class) — same as QuickAddComponent.
      morph(modalContent, gridContent.cloneNode(true), MORPH_OPTIONS);
    }

    if (typeof dialog.showDialog === 'function') {
      dialog.showDialog();
    }
  }
}

if (!customElements.get('pcd-shop-trigger')) {
  customElements.define('pcd-shop-trigger', PcdShopTrigger);
}
